// src/layout/MainLayout.jsx
import React from "react";
import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <div>
      {/* النافبار دائم بكل الصفحات */}
      <Navbar />

      {/* المحتوى يلي بيتغير حسب الصفحة */}
      <main style={{ padding: "0px" }}>
        <Outlet />
      </main>
    </div>
  );
}
